/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1EnvironmentsRemoveEnvironmentVariablesRequestBody = {
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  project: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  app: string;
  /**
   * Identifies a resource by either its unique ID or its slug.
   *
   * @remarks
   * Accepts a prefixed ID (such as 'proj_' or 'app_') or a slug.
   */
  environment: string;
  /**
   * The names of the variables to remove. Keys that exist are deleted; keys
   *
   * @remarks
   * that are not present are ignored, since their absence already matches the
   * requested state.
   *
   * Duplicate keys collapse to a single removal. The whole operation is atomic:
   * if any part fails the environment is left unchanged. Limited to 50
   * variables per request.
   */
  variables: Array<string>;
};

/** @internal */
export type V1EnvironmentsRemoveEnvironmentVariablesRequestBody$Outbound = {
  project: string;
  app: string;
  environment: string;
  variables: Array<string>;
};

/** @internal */
export const V1EnvironmentsRemoveEnvironmentVariablesRequestBody$outboundSchema:
  z.ZodType<
    V1EnvironmentsRemoveEnvironmentVariablesRequestBody$Outbound,
    z.ZodTypeDef,
    V1EnvironmentsRemoveEnvironmentVariablesRequestBody
  > = z.object({
    project: z.string(),
    app: z.string(),
    environment: z.string(),
    variables: z.array(z.string()),
  });

export function v1EnvironmentsRemoveEnvironmentVariablesRequestBodyToJSON(
  v1EnvironmentsRemoveEnvironmentVariablesRequestBody:
    V1EnvironmentsRemoveEnvironmentVariablesRequestBody,
): string {
  return JSON.stringify(
    V1EnvironmentsRemoveEnvironmentVariablesRequestBody$outboundSchema.parse(
      v1EnvironmentsRemoveEnvironmentVariablesRequestBody,
    ),
  );
}
